import { Injectable, NgZone } from '@angular/core';
import {
  Auth,
  GoogleAuthProvider,
  signInWithCustomToken,
  signInWithPopup,
  signOut,
} from '@angular/fire/auth';
import { Firestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  loggedOut = false;
  constructor(
    public firestore: Firestore,
    public auth: Auth,
    public router: Router,
    public ngZone: NgZone
  ) {}

  async loginWithPopup() {
    const provider = new GoogleAuthProvider();
    const params = { prompt: 'select_account' };
    provider.addScope('email');
    provider.setCustomParameters(params);
    return signInWithPopup(this.auth, provider);
  }

  logout() {
    signOut(this.auth).then(() => {
      this.loggedOut = true;
      this.router.navigate(['login']);
    });
    localStorage.removeItem('userSession');
  }

  cypressLogin(customToken: string) {
    return signInWithCustomToken(this.auth, customToken);
  }
}
